<template>
  <div class="commonDialog" @click.stop="">
    <div class="content size12 color33">
      <div class="title size12 head color33">
        <span v-show="state === 'quick'">{{$t('page.quick_track')}}</span>
        <span v-show="state === 'shipper'">{{$t('page.choose_carrier')}}</span>
        <i class="close el-icon-close size16 pointer" @click.stop="close"></i>

      </div>
      <div class="main">
        <shippers-window
          @shippers-close="shippersClose"
          @backQuick="backQuick"
          @close="close">
        </shippers-window>
      </div>
    </div>
  </div>
</template>

<script>
import shippersWindow from './new/shippersWindow.vue'
import LocalStorage from '@/common/localStorage.js'
export default {
  components: {
    shippersWindow
  },
  data () {
    return {
      state: 'shipper',
      shipperData: {}
    }
  },
  created () {

  },
  methods: {
    close () {
      this.$emit('close', false)
    },
    changeState (state) {
      this.state = state
    },
    seachOrder (list) {
      this.$emit('quickSearch', list)
    },
    shippersClose () {
      this.state = 'quick'
      this.shipperData = LocalStorage.get('shippers-choose')
      if (this.shipperData) {
        this.$emit('changeShipper', this.shipperData)
        this.$emit('close', false)
      }
    },
    backQuick () {
      this.state = 'quick'
      this.$emit('quickBack')
    }
  }
}
</script>

<style scoped>
@import '../../static/common-css/detail.css';
  .alert-box .cantent{
    width: 820px;
    position: relative;
  }
  .alert-box .head{
    height: 55px;
    line-height: 55px;
  }
  .alert-box .title .close {
    right: 22px;
    top: 19px;
  }
  .head {
    /*background-color: #1F2A33!important;*/
    /*color: #fff!important;*/
  }
  .infoTit {
    margin: 0px 0 20px;
  }
  .el-icon-close {
    /*color: #fff!important;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/shippersWindow.vue